import client from "../../../../services/session/apiClient";

export function uploadMenu(menu) {
  return client.post('/v5/listingManagement/foodMenu/upload', menu).then(resp => resp.data);
}

export function getMenu(menuId) {
  return client.get(`/v5/listingManagement/foodMenu/${menuId}`).then(resp => resp.data);
}